/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x596894 from'./../../message.js';class RevisionHistoryUpdateRevisionsResponse extends _0x596894{constructor(_0x119209){super(),this['requestId']=_0x119209;}['toJSON'](){return{'requestId':this['requestId']};}static['fromJSON'](_0x1b9dce){return new RevisionHistoryUpdateRevisionsResponse(_0x1b9dce['requestId']);}}RevisionHistoryUpdateRevisionsResponse['DESCRIPTOR_NAME']='RevisionHistoryUpdateRevisionsResponse',RevisionHistoryUpdateRevisionsResponse['DESCRIPTOR']={'fields':{'requestId':{'type':'uint32','id':0x1}}};export default RevisionHistoryUpdateRevisionsResponse;